module.exports = __webpack_public_path__ + "img/sport_tv_3a.4d1b9407.png";